import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EstateComparisonListing } from './Pages'

export const EstateComparisonReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={EstateComparisonListing} />
    </Fragment>
)